import { CheckoutOrderValidationError, CheckoutOrderValidationRule } from "../enum/checkout-order-validation.enum";

export const checkoutOrderDataRule: CheckoutOrderValidationRule = ({
	storeId,
	localChannelId,
	hasCartTotals,
}) =>
	!storeId ||
	!localChannelId ||
	!hasCartTotals
		? CheckoutOrderValidationError.OrderDataIncomplete
		: null;
